import { render, staticRenderFns } from "./ServiceProviderDocumentDetail.vue?vue&type=template&id=613367fd&"
import script from "./ServiceProviderDocumentDetail.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderDocumentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports